import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, createTenant, valuesAnalyze, changeViewForms, validEmail, validName } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function TenantCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenantData, setTenantData] = useState({ name: '', tenant: '' });

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(() => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTextAndSpace } = valuesAnalyze;

    if(name === 'deleteRecDays') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'deleteRecDays' && value > 365) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);

      return checkValueIsNumber;
    };

    if(name === 'email') {
      const emailIsValid = validEmail(value);
      changeScreen(emailIsValid, name);
      return emailIsValid;
    }

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'name' || name === 'role') {
      const checkValueIsCharacters = isTextAndSpace(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }

    if(name === 'deleteRecDays') {
      const checkValueIsCharacters = checkNumber(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    if(Object.keys(validate).length >= 4) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    setValues((prevState) => prevState, values[name] = value );
    return;
  };

  const sendDataTenantGenerate = async () => {
    const fetchTenants = await createTenant(values);
    toggleIsChangeFormElements('alert-create-tenant', 'is-hidden');
    const result = Object.keys(fetchTenants).length > 0 ? true : false;
    if(result) setTenantData(fetchTenants)
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-tenant');
      setTimeout(() => {
        // return history.push('/config/ramal/lista');
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">ADICIONAR CLIENTE</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-create-tenant" name="alert-create-tenant" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-tenant') }></button>
            </div>
            <div className="message-body">
              Não é possível gerar ramal com os campos abaixo não preenchidos.
              <br />
              Por favor, verifique os dados e clique novamente no botão <strong>Criar Cliente</strong> 
            </div>
          </article>
          <article id="error-create-tenant" name="error-create-endpoints" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Erro!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#error-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Não foi possível adicionar o cliente!
              <br />
              Verifique se o cliente já existe!
            </div>
          </article>
          <article id="success-create-tenant" name="success-create-tenant" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-tenant') }></button>
            </div>
            <div className="message-body">
              Cliente criado com <strong>sucesso</strong>!<br/>
              <strong>Nome: </strong>{ `${tenantData.name}` } - <strong>Feixe: </strong> { `${tenantData.tenant}` }
            </div>
          </article>
          <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
            <div className="columns mx-2">
              <div className="column is-2 is-offset-1 field">
                <label className="label">Cliente
                  <div className="control">
                  <input className="input" name="name" type="text" onChange={(e) => handleChangeValues(e.target)} placeholder="Insira o nome do cliente" />
                  <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">E-mail
                  <div className="control">
                  <input className="input" name="email" type="text" onBlur={(e) => handleChangeValues(e.target)} placeholder="fulano@empresa.com.br" />
                  <p name="email-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Senha
                  <div className="control">
                  <input className="input" name="password" type="text" onBlur={(e) => handleChangeValues(e.target)} placeholder="Tamanho mínimo 6 caract. (@!#$&)"/>
                  <p name="password-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="field column is-2">
                <label className="label">Tempo de Gravação
                  <div className="control">
                  <input className="input" name="deleteRecDays" type="number" onChange={(e) => handleChangeValues(e.target)} placeholder="Tamanho mínimo 6 caract. (@!#$&)"/>
                  <p name="deleteRecDays-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Tipo
                  <div className="control">
                    <div name="role" className="select is-fullwidth">
                      <select className="select" name="role" onChange={(e) => handleChangeValues(e.target)} >
                        <option value="">Selecione</option>
                        <option value="root">Técnico</option>
                        <option value="admin">Admin</option>
                        <option value="user">Usuário</option>
                      </select>
                      <p name="role-invalid-data" className='has-text-danger is-size-7 is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </form>
          <div id="button-send-form" name="button-send-form" className="columns mt-3">
            <div className="field column mt-3 is-half is-2 is-offset-5 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth mt-3" type="submit" onClick={ () => sendDataTenantGenerate() }>
                {/* <button className="button is-info is-fullwidth mt-3" type="submit" disabled={ disable } onClick={ () => sendDataTenantGenerate() }> */}
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                  </span>
                  <span>
                    CRIAR CLIENTE
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-half is-offset-one-quarter has-text-centered">
              <hr className="dropdown-divider"/>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default TenantCreate;
